import {combineReducers} from 'redux';
import themeReducer from './theme';
import userTypes from './userTypes';
import licenseTypes from './licenseTypes';
import sendMail from './sendMail';
import industrySector from './industry';

export const generalReducer = combineReducers({
  theme: themeReducer,
  userTypes,
  licenseTypes,
  industrySector,
  sendMail: sendMail,
});
